import { NextButton } from 'components/NextButton';
import { PrevButton } from 'components/PrevButton';
import { useContext, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { ReasonDropdown } from 'pages/profile/components/ReasonDropdown';
import { FormItem, WisoryTextArea } from 'components/Inputs';
import clsx from 'clsx';
import { ProfileFooter } from 'pages/profile/components/Layout/components/ProfileFooter';
import { BookingFormLayout } from 'pages/profile/components/Layout';
import { BookingFormContext } from 'pages/profile/context2';
import { CustomerInfo } from 'pages/profile/types';

export const GoalAndPurposeStep = () => {
  const { t } = useTranslation();
  const { setState, setStep, state } = useContext(BookingFormContext);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ goal: string; purpose: string }>({
    mode: 'onSubmit',
    defaultValues: {
      goal: state.customerInfo.goal,
      purpose: state.customerInfo.purpose,
    },
  });
  const submitBtnRef = useRef<HTMLButtonElement>(null);

  const saveValueToStore = (fieldName: keyof CustomerInfo, value: any) => {
    setState((draft) => {
      // @ts-ignore
      draft.customerInfo[fieldName] = value;
    });
  };

  const onNextBtnClick = () => {
    setStep('login-or-enter-as-guest');
  };

  const onPrevBtnCick = () => {
    setStep('select-time-or-suggest-timespans');
  };

  return (
    <>
      <form onSubmit={handleSubmit(onNextBtnClick)} className="text-white mb-0">
        <BookingFormLayout
          footer={
            <ProfileFooter className="flex justify-between">
              <PrevButton type="button" onClick={onPrevBtnCick}>
                {t('REACT_BOOKING_FRONTEND.common.backButton')}
              </PrevButton>
              <NextButton type="submit" componentRef={submitBtnRef}>
                {t('REACT_BOOKING_FRONTEND.common.nextButton')}
              </NextButton>
            </ProfileFooter>
          }
        >
          <div className={clsx('wisory-title', 'mb-3')}>
            {t('REACT_BOOKING_FRONTEND.booking2.goalAndPurposeScreenTitle')}
          </div>
          <div className="mb-9 font-openSans text-black">
            {t('REACT_BOOKING_FRONTEND.booking2.goalAndPurposeScreenSubtitle')}
          </div>
          <div className="w-full">
            <FormItem label={t('REACT_BOOKING_FRONTEND.booking2.goalLabel')} errorMessage={errors.goal?.message}>
              <Controller
                control={control}
                name="goal"
                render={({ field }) => (
                  <ReasonDropdown
                    autoFocus
                    value={field.value}
                    onChange={(v) => {
                      field.onChange(v);
                      saveValueToStore('goal', v);
                    }}
                  />
                )}
                rules={{
                  required: t('REACT_BOOKING_FRONTEND.common.validations.required'),
                }}
              />
            </FormItem>
          </div>
          <div className="w-full">
            <FormItem
              label={t('REACT_BOOKING_FRONTEND.booking2.purposeLabel')}
              errorMessage={errors.purpose?.message}
              className="w-full"
            >
              <WisoryTextArea
                style={{ height: 176 }}
                {...register('purpose', {
                  required: t('REACT_BOOKING_FRONTEND.common.validations.required'),
                  minLength: {
                    value: 30,
                    message: t('REACT_BOOKING_FRONTEND.suggestedScreen.purposeMinLength'),
                  },
                  onChange(e) {
                    saveValueToStore('purpose', e.target.value);
                  },
                })}
              />
            </FormItem>
            {t('REACT_BOOKING_FRONTEND.booking2.purposeLabelExtra') && (
              <i className="font-openSans text-black mt-3">
                <Trans
                  t={t}
                  i18nKey="REACT_BOOKING_FRONTEND.booking2.purposeLabelExtra"
                  components={{
                    ul: <ul />,
                    li: <li />,
                  }}
                />
              </i>
            )}
          </div>
        </BookingFormLayout>
      </form>
    </>
  );
};
